import { render, staticRenderFns } from "./SingleChoices.vue?vue&type=template&id=c19351a2&scoped=true&lang=pug&"
import script from "./SingleChoices.vue?vue&type=script&lang=ts&"
export * from "./SingleChoices.vue?vue&type=script&lang=ts&"
import style0 from "./SingleChoices.vue?vue&type=style&index=0&id=c19351a2&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c19351a2",
  null
  
)

export default component.exports